import { ToggleButton } from '@/common'
import useI18n from '@/shared/hooks/usei18n'
import { useNetMassDisplay } from '@/shared/netMassDisplay/NetMassDisplayUnitContext'

export function NetMassDisplayUnitToggle() {
  const { unit, setUnit } = useNetMassDisplay()
  const { t } = useI18n()

  return (
    <div
      className="flex shrink-0"
      role="group"
      aria-label={t('common:netMassDisplay.toggle.groupLabel')}
    >
      <ToggleButton
        isActive={unit === 'tonnes'}
        onClick={() => setUnit('tonnes')}
        sizeType="sm"
        className="h-10 min-w-16"
      >
        {t('common:netMassDisplay.toggle.tonnes')}
      </ToggleButton>
      <ToggleButton
        isActive={unit === 'kilograms'}
        onClick={() => setUnit('kilograms')}
        sizeType="sm"
        className="h-10 min-w-16"
      >
        {t('common:netMassDisplay.toggle.kilograms')}
      </ToggleButton>
    </div>
  )
}
